export default "__VITE_ASSET__Bxt6cVvE__"